// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"b6374237","156":"097d0179","341":"d04918e4","438":"39bbd81a","706":"d5aae2dd","726":"83ecf2f4"}[chunkId] + ".chunk.js";
};